export default __webpack_public_path__ + "static/media/Spin torre M_Interactive LightMix0069.5e414f9b.webp";